import { omit } from "lodash";
import { safeGET, safePOST } from "./SafeClient";
import { Tactic } from "../../types/TacticTypes";
import { splitHtmlByH2 } from "../Html";

export function splitContentByH2(tactic: Tactic): Tactic {
    return {
        ...tactic,
        contentV1: splitHtmlByH2(tactic.content ?? ""),
    };
}

export async function getTactics(abort?: any): Promise<Tactic[]> {
    const tactics = await safeGET<Tactic[]>(`/api/tactic`, abort);
    return tactics?.map(splitContentByH2);
}

export async function getTacticById(orderFormId: number, abort?: any): Promise<Tactic> {
    const tactic = await safeGET<Tactic>(`/api/tactic/${orderFormId}`, abort);
    return tactic && splitContentByH2(tactic);
}

export async function upsertTactic(tactic: Tactic, abort?: any) {
    const tacticToSave = omit(tactic, ["contentV1"]);
    return safePOST(`/api/tactic`, tacticToSave, abort);
}
